import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLocation } from 'react-router';
import { Link } from 'react-router';
import loginActions from '../Login/LoginActions';

import auth from '../../auth';
import style from './Layout.module.css';
import logoImage from '../../assets/img/logo.png';
import {Translate} from 'react-redux-i18n';

// import shakehandsIcon from '../../assets/img/shakehands.png';

function Header(props) {
  const location = useLocation();
  const { curUser, setCurUser } = props;
  
  useEffect(() => {
    if (!curUser || !curUser.name) {
      setCurUser(auth.getUser());
    }
  }, [curUser, setCurUser]);
  
  const activeRoute = location.pathname;

  const active = (current) => {
    let found = 0;

    if (Array.isArray(current)) {
      found = current.some(route => RegExp(route).test(activeRoute));
    } else {
      found = activeRoute === current;
    }

    return found ? 'active' : '';
  };

  const guestMenu = (
    <div className={`navbar-nav me-auto mb-2 mb-lg-0 ${style.nav}`}>
      <div className={`nav-item ${active('/login')}`}>
        <Link to="/login" className={`nav-link ${style.link}`}>
          <span className={`fas fa-sign-in-alt text-center ${style.icon}`}/>
          <Translate value="auth.Login"/>
        </Link>
      </div>
    </div>
  );

  const authenticatedMenu = user => (
    <ul className={`navbar-nav ${style.nav}`}>
      <li className={`nav-item ${active('/')}`}>
        <Link to="/" className={`nav-link ${style.link}`}>
          <span className={`fas fa-fire text-center ${style.icon}`}/>
          <Translate value="common.Home"/>
        </Link>
      </li>
      { auth.can('scenario-list') &&
      <li className={`nav-item ${active('/scenarios')}`}>
        <Link to="/scenarios" className={`nav-link ${style.link}`}>
          <span className={`fas fa-map text-center ${style.icon}`}/>
          <Translate value="common.Scenarios"/>
        </Link>
      </li>
      }
      {
        !(curUser && curUser.company && curUser.company.hideMutualAid) &&
        <li className={`nav-item ${active('/mutual-aid')}`}>
          <Link to="/mutual-aid" className={`nav-link ${style.link}`}>
            <span className={`fas fa-handshake text-center ${style.icon}`}>
              {/*<img src={shakehandsIcon} style={{height: '25px'}} /> */}
            </span>
            <Translate value="common.MutualAid"/>
          </Link>
        </li> 
      }
      { auth.can('exercise-list') &&
      <li className={`nav-item ${active(['/exercises', '/exercises/create', '/exercises/join', '/exercises/run'])}`}>
        <Link to="/exercises" className={`nav-link ${style.link}`}>
          <span className={`fas fa-sitemap text-center ${style.icon}`}/>
          <Translate value="common.Exercises"/>
        </Link>
      </li>
      }
      <li className="nav-item">
        <a href="/webclient/#/login?hide_ui=true" target="_blank" className={`nav-link ${style.link}`}>
          <span className={`fas fa-play text-center ${style.icon}`} />
          <Translate value="common.WebClient" />
        </a>
      </li>
	{/* <li className="nav-item">
        <a href="/webbuilder" className={`nav-link ${style.link}`}>
          <span className={`fas fa-wrench text-center ${style.icon}`}/>
          <Translate value="common.WebBuilder"/>
        </a>
      </li> */}
      { auth.can('user-list') &&
      <li className={`nav-item ${active('/users')}`}>
        <Link to="/users" className={`nav-link ${style.link}`}>
          <span className={`fas fa-users text-center ${style.icon}`}/>
          <Translate value="common.Users"/>
        </Link>
      </li>
      }
      { auth.can('company-list') &&
      <li className={`nav-item ${active('/companies')}`}>
        <Link to="/companies" className={`nav-link ${style.link}`}>
          <span className={`fas fa-building text-center ${style.icon}`}/>
          <Translate value="common.Companies"/>
        </Link>
      </li>
      }
      { auth.can('blacklist-list') &&
      <li className={`nav-item ${active('/blacklist')}`}>
        <Link to="/blacklist" className={`nav-link ${style.link}`}>
          <span className={`fas fa-gavel text-center ${style.icon}`}/>
          <Translate value="common.BlackList"/>
        </Link>
      </li>
      }
      <li className={`nav-item ${active('/help')}`}>
        <Link to="/help" className={`nav-link ${style.link}`}>
          <span className={`fas fa-question text-center ${style.icon}`}/>
          <Translate value="common.Help"/>
        </Link>
      </li>
      { auth.can('user-update-self') &&
        <li className="nav-item">
          <Link to={`/user/${user._id}`} className={`nav-link ${style.link}`}>
            <span className={`fas fa-user-circle text-center ${style.icon}`}/>
            {user.name.split(' ')[0]}
          </Link>
        </li>
      }
      <li className="nav-item">
        <Link to="/logout" className={`nav-link ${style.link}`}>
          <span className={`fas fa-sign-out-alt text-center ${style.icon}`}/>
          <Translate value="auth.Logout"/>
        </Link>
      </li>
    </ul>
  );

  const isLoggedIn = auth.loggedIn();
  const user = Object.assign({name: ''}, curUser);

  return (
    <nav className={`navbar navbar-expand-lg navbar-light bg-light py-0 ${style.navbar}`}>
      <div className="container-fluid">
        <button type="button" className={`navbar-toggler ${style.collapseBtn}`} data-bs-toggle="collapse"
                data-bs-target="#collapse-menu" aria-expanded="false">
          <span className="visually-hidden"><Translate value="home.toggleNav"/></span>
          <span className="navbar-toggler-icon"></span>
        </button>
        <Link to="/" className={`navbar-brand ${style.brand}`}>
            {
              (user.company && user.company.logoUrl) ?
                <img alt="Logo" src={user.company.logoUrl} role="presentation"/>
                :
                <img alt="Logo" src={logoImage} role="presentation"/>
            }
        </Link>
        <div className={`${style.companyTitle}`}>
          {
            (user && user.company && !!!user.company.hideCompanyName) &&
               <h3>{user.company.name}</h3>
          }
        </div>
        <div className={`collapse navbar-collapse ${style.navCollapse}`} id="collapse-menu">
          { isLoggedIn && authenticatedMenu(user) }
          { !isLoggedIn && guestMenu }
        </div>
      </div>
    </nav>
  );
}

Header.propTypes = {
  curUser: PropTypes.object,
  setCurUser: PropTypes.func,
  socketConnected: PropTypes.bool,
};

const mapStateToProps = state => ({
  socketConnected: state.exercises.connected,
  curUser: state.login.userData
});

const mapDispatchToProps = {
  setCurUser: loginActions.setCurUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);
